import {DICTIONARY_DETAIL_PARAMS} from './dictionaryConstants';
import {HTTP_STATUS_CODES} from '../../common/network/httpConstants';
import {generateCategoryUrl} from '../category/categoryUtils';
import {generateQueryString} from '../../common/url/urlUtils';
import {DICTIONARY_INITIAL_SHOW_COUNT} from './dictionaryConstants';

function checkForDictionaryToCategoryRedirection(
  dictionaryDetailResponseData,
  currentCategoryUrlKeyword,
  currentCategoryId,
  currentQueryParams,
) {
  let redirection;

  if (dictionaryDetailResponseData.redirection && dictionaryDetailResponseData.redirection.url) {
    redirection = {
      ...dictionaryDetailResponseData.redirection,
    };
  } else if (currentQueryParams[DICTIONARY_DETAIL_PARAMS] && !dictionaryDetailResponseData.data) {
    const queryParams = delete currentQueryParams[DICTIONARY_DETAIL_PARAMS];
    redirection = {
      isInternal: true,
      type: HTTP_STATUS_CODES.MOVED_PERMANENTLY,
      url: generateCategoryUrl(
        currentCategoryUrlKeyword,
        currentCategoryId,
        {
          queryParams,
        },
      ),
    };
  }

  return redirection;
}

function shuffleArray(array) {
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;

  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

const getQueryString = (keyword) => {
  return generateQueryString({
    [DICTIONARY_DETAIL_PARAMS]: keyword,
  });
}

const getDictionaryData = ({dictionary = [], isAll = false}) => {
  if (dictionary?.length > DICTIONARY_INITIAL_SHOW_COUNT && !isAll) {
    return dictionary.slice(0, DICTIONARY_INITIAL_SHOW_COUNT);
  }

  return dictionary;
}

export {
  getQueryString,
  getDictionaryData,
  checkForDictionaryToCategoryRedirection,
  shuffleArray,
}
